//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Balloon from '/react4xp/components/Balloon'
import Mask from '/react4xp/components/Mask'
import Image from '/react4xp/components/Image'
import Video from '/react4xp/components/Video'
import RichText from '/react4xp/components/RichText'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import ProductsShadow from '/react4xp/components/Svg/Others/ProductsShadow'

// prop types
export interface LandingPageHeroProps {
    title?: string
    type?: 'image' | 'video'
    image?: {
        src?: string
        srcMedium?: string
        alt?: string
    }
    video?: {
        url?: string
        poster?: string
    }
    bottomRightIcons?: boolean
    content?: string
    bgColor?: string
}

export default function LandingPageHero({
    title,
    type,
    image,
    video,
    bottomRightIcons,
    content,
    bgColor
}: LandingPageHeroProps) {
    return (
        <Section
            bgColor={bgColor}
            paddingTop='none'
            noSeparator
            className='landing-page-hero'
        >
            <div className='container'>
            
                <div className='landing-page-hero__flex'>

                    {isNonWhitespaceString(title) && (
                        <div className='landing-page-hero__flex__balloon'>
                            <Balloon
                                arrow='bottom-left'
                                arrowSize='medium'
                                arrowSide='right'
                                balloonSide='left'
                                balloonColor='white'
                                spacing='medium'
                            >
                                <h1 className='h1-hero-small line-break'>
                                    {title}
                                </h1>
                            </Balloon>
                        </div>
                    )}

                    {(image?.src || video?.url) && (
                        <div className={clsx(
                            type === 'image' && 'landing-page-hero__flex__image-wrapper',
                            type === 'video' && 'landing-page-hero__flex__video-wrapper'
                        )}>
                            <Mask
                                className={clsx(
                                    type === 'image' && 'landing-page-hero__flex__image-wrapper__image',
                                    type === 'video' && 'landing-page-hero__flex__video-wrapper__video'
                                )}>

                                {image?.src && (
                                    <Image
                                        src={image?.src}
                                        srcMedium={image?.srcMedium}
                                        width={900}
                                        alt={image?.alt}
                                        sizes='
                                            (max-width: 768px) 100vw,
                                            50vw
                                        '
                                        className='cover'
                                    />
                                )}

                                {video?.url && (
                                    <Video
                                        video={{
                                            url: video?.url,
                                            playButtonColor: 'blue',
                                            playTextColor: 'white',
                                            videoType: 'default',
                                            playText: 'Spill av video',
                                            poster: video?.poster
                                        }}
                                        className='cover'
                                    />
                                )}

                            </Mask>

                            {bottomRightIcons && (
                                <ProductsShadow className='landing-page-hero__flex__icon' />
                            )}

                        </div>
                    )}

                </div>

                {isNonWhitespaceString(content) && (
                    <div className='row'>
                        <div className='col-md-11 col-lg-8'>
                            <Mask
                                className='landing-page-hero__content'
                                bgColor='white'
                                spacing='small'
                            >
                                <RichText content={content} />
                            </Mask>
                        </div>
                    </div>
                )}

            </div>
        </Section>
    )
}